import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/Egresos.css';

function Egresos() {
  const [formData, setFormData] = useState({
    nombres: '',
    identificacion: '',
    fechaEgreso: '',
    concepto: '',
    servicioPublico: '',
    factura: '',
    valor: '',
    descripcion: '',
    tipoDocumento: ''
  });

  const [conceptos, setConceptos] = useState([]);
  const [serviciosPublicos, setServiciosPublicos] = useState([]);
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [mostrarServicioPublico, setMostrarServicioPublico] = useState(false);
  const [fechaEgreso, setFechaEgreso] = useState('');
  //const [totalValor, setTotalValor] = useState(0); // Estado para almacenar el total

  // Obtener el ID del usuario registrante
  const getUserId = () => {
    let userId = sessionStorage.getItem('userId');
    if (!userId) {
      // Intentar obtener desde localStorage (UserContext)
      const currentUser = localStorage.getItem('currentUser');
      if (currentUser) {
        const user = JSON.parse(currentUser);
        userId = user.id;
      }
    }
    return userId ? parseInt(userId) : 0;
  };

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    // Obtener conceptos desde la API
    axios.get(`${apiUrl}/Donantes/Conceptos/Egresos`).then((response) => {
      setConceptos(response.data);
    });

    // Obtener servicios públicos desde la API
    axios.get(`${apiUrl}/Donantes/Conceptos/ServiciosPublicos`).then((response) => {
      setServiciosPublicos(response.data);
    });

    // Obtener tipos de documento desde la API
    axios.get(`${apiUrl}/Donantes/TiposIdentificacion`).then((response) => {
      setTiposDocumento(response.data);
    });
  }, [apiUrl]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Mostrar campos de "Servicio Público" y "# Factura" solo si se selecciona "Servicios Públicos Capilla"
    if (name === 'concepto' && value === '4') {
      setMostrarServicioPublico(true);
    } else if (name === 'concepto') {
      setMostrarServicioPublico(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const id_Registrante = getUserId();
    
    if (!id_Registrante || id_Registrante === 0) {
      alert('No se pudo identificar el usuario registrante. Por favor, inicie sesión nuevamente.');
      return;
    }

    // Preparar los datos de egreso
    const egresoData = {
      id_Registrante,
      fecha_Egreso: fechaEgreso,
      fecha_Registro: new Date().toISOString(),
      id_Concepto: parseInt(formData.concepto),
      factura: formData.factura,
      valor: parseFloat(formData.valor),
      descripcion: formData.descripcion,
      id_tipoIdentificacion: parseInt(formData.tipoDocumento),
      identificacion: parseInt(formData.identificacion),
      Nombres: formData.nombres
    };

    // Solo agregar id_ServicioPublico si fue seleccionado
    if (mostrarServicioPublico && formData.servicioPublico) {
      egresoData.id_ServicioPublico = parseInt(formData.servicioPublico);
    }

    // Lógica para enviar los datos a la API
    axios.post(`${apiUrl}/Donantes/Egresos`, egresoData)
      .then((response) => {
        alert('Egreso registrado exitosamente');
        
        // Actualizar el total sumando el nuevo valor ingresado
       // setTotalValor((prevTotal) => prevTotal + parseFloat(formData.valor));

        setTimeout(() => {
          window.location.href = '/opciones';
        }, 2000);
      })
      .catch((error) => {
        alert('Error al registrar el egreso');
        console.error('Error al registrar egreso:', error);
        console.error(egresoData);
      });
  };

  const handleGoBack = () => {
    // Redirigir a la página de Ofrendas
    window.location.href = '/opciones';
  };

  return (
    <div className="egresos-container">
      <h1 className="egresos-title">Registrar Egresos</h1>
      <form onSubmit={handleSubmit} className="egresos-form">
        <div>
          <label>Concepto:</label>
          <select
            name="concepto"
            value={formData.concepto}
            onChange={handleChange}
            required
          >
            <option value="">Selecciona un concepto</option>
            {conceptos.map((concepto) => (
              <option key={concepto.id} value={concepto.id}>
                {concepto.concepto}
              </option>
            ))}
          </select>
        </div>

        {mostrarServicioPublico && (
          <>
            <div>
              <label>Servicio Público:</label>
              <select
                name="servicioPublico"
                value={formData.servicioPublico}
                onChange={handleChange}
                required={mostrarServicioPublico}
              >
                <option value="">Selecciona un servicio público</option>
                {serviciosPublicos.map((servicio) => (
                  <option key={servicio.id} value={servicio.id}>
                    {servicio.servicio}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label># Factura:</label>
              <input
                type="text"
                name="factura"
                value={formData.factura}
                onChange={handleChange}
                required={mostrarServicioPublico}
              />
            </div>
          </>
        )}

        <div>
          <label>Nombres y Apellidos o Razón Social:</label>
          <input
            type="text"
            name="nombres"
            value={formData.nombres}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Tipo de Documento:</label>
          <select
            name="tipoDocumento"
            value={formData.tipoDocumento}
            onChange={handleChange}
            required
          >
           <option value="">Selecciona un Tipo de Identificacion</option>
            {tiposDocumento.map((tipo) => (
              <option key={tipo.id} value={tipo.id}>
                {tipo.tipo_Identificacion}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Identificación (Cédula o NIT):</label>
          <input
            type="text"
            name="identificacion"
            value={formData.identificacion}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Valor:</label>
          <input
            type="number"
            name="valor"
            value={formData.valor}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Descripción:</label>
          <textarea
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
          />
        </div>

        <div>
          
        <label htmlFor="fechaEgreso">Fecha de Egreso:</label>
            <input
              type="date"
              id="fechaEgreso"
              value={fechaEgreso}
              onChange={(e) => setFechaEgreso(e.target.value)}
              required
            />
        </div>

        <button type="submit" className="submit-button">Registrar Egreso</button>
        
        {/* Botón para regresar a Ofrendas */}
        <button type="button" className="submit-back" onClick={handleGoBack}>
          Regresar al menú
        </button>

        
      </form>
    </div>
  );
}

export default Egresos;
